if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        paginationEl: '.swiper-pagination',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.cardStyle = this.dataset.cardStyle;
      this.itemSize = this.dataset.itemSize;
      this.columnsDesktop = this.dataset.columnsDesktop;
      this.autoplayDelay = parseInt(this.dataset.autoplay, 10) || 0;

      this.sliderInstance = false;

      this.initSlider();
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object') return;

      const additionalModules = [FoxTheme.Swiper.Mousewheel, FoxTheme.Swiper.Pagination];
      if (this.autoplayDelay > 0) additionalModules.push(FoxTheme.Swiper.Autoplay);

      const sliderOptions = {
        slidesPerView: 'auto',
        spaceBetween: 8,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: {
          el: this.section.querySelector(this.selectors.paginationEl),
          clickable: !FoxTheme.config.mqlMobile,
          dynamicBullets: FoxTheme.config.mqlMobile,
          dynamicMainBullets: 3,
        },
        loop: false,
        rewind: true,
        threshold: 2,
        mousewheel: {
          enabled: !FoxTheme.config.mqlMobile,
          forceToAxis: true,
        },
        ...(this.autoplayDelay > 0 && {
          autoplay: {
            delay: this.autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
        }),
        breakpoints: {
          768: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView: this.itemSize == 'fixed' ? (this.columnsDesktop > 4 ? 4 : this.columnsDesktop) : 'auto',
          },
          1024: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? this.columnsDesktop > 6
                  ? this.columnsDesktop - 1
                  : this.columnsDesktop
                : 'auto',
          },
          1280: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView: this.itemSize == 'fixed' ? this.columnsDesktop : 'auto',
          },
        },
      };

      this.classList.add(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.grid);
      this.sliderWrapper.classList.add(this.classes.swiperWrapper);

      this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions, additionalModules);
      this.sliderInstance.init();

      const focusableElements = FoxTheme.a11y.getFocusableElements(this);

      focusableElements.forEach((element) => {
        element.addEventListener('focusin', () => {
          const slide = element.closest('.swiper-slide');
          const realIndex = Number(slide?.dataset.swiperSlideIndex ?? slide?.dataset.index ?? 0);
          this.sliderInstance.slider.slideToLoop(realIndex);
        });
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }
  }
  customElements.define('collection-list', CollectionList);
}
